import React from "react";

import { Text, Group } from "@mantine/core";

export default function TaxAndDiscount({ currency, tax_amount, discount_type, discount_value }) {
  return (
    <>
      {typeof tax_amount === "number" && (
        <Group position="apart" mb={15}>
          <Text size="md">Estimated tax</Text>
          <Text size="md">
            {currency}{tax_amount}
          </Text>
        </Group>
      )}
      {!!discount_type && (
        <Group position="apart" mb={15}>
          <Text size="md">Discount</Text>
          <Text size="md">
            {discount_type === "amount" ? `${currency}${discount_value}` : `${discount_value}%`}
          </Text>
        </Group>
      )}
    </>
  );
}
